module.exports = __webpack_public_path__ + "img/active-d.1cef8ba3.png";